/**
 * GraphQL queries for authentication and session initialization
 */

/**
 * Batched session initialization query - replaces 5 sequential auth requests with 1.
 * Returns all data needed to initialize the authenticated user session.
 */
export const INITIALIZE_SESSION_QUERY = `
  query InitializeSession {
    initializeSession {
      user {
        id
        email
        username
        fullName
        roleType
        department
        isSuperuser
        superAdminType
        organizationId
        organizationName
        organizationBranding
      }
      shouldShowOnboarding
      claimsStatus {
        needsRefresh
        isTrial
        trialExpiresAt
        trialId
      }
      managedOrganizations {
        id
        name
        description
        domain
        ownershipStatus
        parentOrganization {
          id
          name
        }
      }
    }
  }
`;
